import usePrimeQuotaStore from '@stores/prime-quota/store';
import { getPrimeGlobalProps } from '@stores/prime-quota/selectors';
import { UserPlatformPlan } from '@stores/prime-quota/types';

const PRIME_CONTENT_TYPE_ID = 507;

const hasActivePrimeSubscription = (subscriptions = [], goalUid) =>
  subscriptions.some((entry) => {
    const contentTypeId =
      entry?.contentTypeId ??
      entry?.content_type_id ??
      entry?.subscription?.contentTypeId ??
      entry?.subscription?.content_type_id;
    const timeRemaining = entry?.time_remaining ?? entry?.timeRemaining ?? 0;
    const entryGoalUid =
      entry?.goalUid ?? entry?.goal_uid ?? entry?.subscription?.value?.uid;

    const matchesGoal = !goalUid || entryGoalUid === goalUid;

    return (
      Number(contentTypeId) === PRIME_CONTENT_TYPE_ID &&
      timeRemaining > 0 &&
      matchesGoal
    );
  });

export const syncPrimeSubscriptionContext = ({
  subscriptions = [],
  goalUid = null
} = {}) => {
  const userPlatformPlan = hasActivePrimeSubscription(subscriptions, goalUid)
    ? UserPlatformPlan.PAID
    : UserPlatformPlan.FREE;

  usePrimeQuotaStore.getState().hydratePrimeQuota({ userPlatformPlan });
};

export const getAnalyticsGlobalProps = () => getPrimeGlobalProps();
